import './header.scss';

/* global topbar */

/**
 * Header Component
 * Handles header functionality including menu toggle, avatar loading, and OpenReplay initialization.
 */
export default () => {
	const $container = $( '[data-component="header"]' );

	if ( !$container.length ) {
		return;
	}

	const config = $container.data( 'config' ) || {
	};

	// Menu toggle functionality.
	$( '.js-menu-toggle' ).on( 'click', function ( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.sidebar, .wrapper, .header, body, html .layout' ).toggleClass( 'is-active' );
		$( '.sidebar-hidden-xs' ).toggleClass( 'd-none' );
	} );

	/**
	 * Read the explicitly stored CP color theme, if any.
	 *
	 * @returns {string|null} 'light', 'dark', or null when unset/invalid.
	 */
	const getStoredTheme = () => {
		try {
			const stored = localStorage.getItem( 'cp-theme' );

			if ( stored === 'light' || stored === 'dark' ) {
				return stored;
			}
		} catch ( e ) {
			// Ignore storage errors (private mode, quota, etc.).
		}

		return null;
	};

	/**
	 * Resolve the theme to apply: stored preference, else system preference.
	 *
	 * @returns {string} 'light' or 'dark'.
	 */
	const getPreferredTheme = () => {
		const stored = getStoredTheme();

		if ( stored ) {
			return stored;
		}

		return window.matchMedia( '(prefers-color-scheme: dark)' ).matches ? 'dark' : 'light';
	};

	/**
	 * Mirror the effective theme to a first-party cookie for set-language.php.
	 *
	 * @param {string} theme 'light' or 'dark'.
	 */
	const persistThemeCookie = ( theme ) => {
		try {
			document.cookie = `cp_theme=${theme}; path=/; Max-Age=31536000; SameSite=Lax; Secure`;
		} catch ( e ) {
			// Ignore cookie errors.
		}
	};

	/**
	 * Keep hidden cp_theme fields on language forms in sync with the active theme.
	 *
	 * @param {string} theme 'light' or 'dark'.
	 */
	const syncLanguageFormThemeInputs = ( theme ) => {
		$( 'form[action*="set-language.php"] input[name="cp_theme"]' ).val( theme );
	};

	/**
	 * Apply a color theme to the document and sync the header toggle UI.
	 *
	 * @param {string} theme 'light' or 'dark'.
	 * @param {boolean} persist Whether to write the choice to localStorage.
	 */
	const setTheme = ( theme, persist = true ) => {
		const nextTheme = theme === 'dark' ? 'dark' : 'light';

		document.documentElement.setAttribute( 'data-bs-theme', nextTheme );
		persistThemeCookie( nextTheme );
		syncLanguageFormThemeInputs( nextTheme );

		if ( persist ) {
			try {
				localStorage.setItem( 'cp-theme', nextTheme );
			} catch ( e ) {
				// Ignore storage errors.
			}
		}

		const $toggle = $( '.js-theme-toggle' );

		if ( !$toggle.length ) {
			return;
		}

		const $icon = $toggle.find( '[data-theme-icon]' );
		const labelLight = $toggle.attr( 'data-label-light' ) || '';
		const labelDark = $toggle.attr( 'data-label-dark' ) || '';

		if ( nextTheme === 'dark' ) {
			$icon.removeClass( 'fa-moon' ).addClass( 'fa-sun' );
			$toggle.attr( 'aria-label', labelLight );
		} else {
			$icon.removeClass( 'fa-sun' ).addClass( 'fa-moon' );
			$toggle.attr( 'aria-label', labelDark );
		}
	};

	// Sync toggle icon/label with the theme already set by the head FOUC script.
	setTheme( getPreferredTheme(), false );

	$( '.js-theme-toggle' ).on( 'click', function ( e ) {
		e.preventDefault();

		const current = document.documentElement.getAttribute( 'data-bs-theme' ) === 'dark' ? 'dark' : 'light';

		setTheme( current === 'dark' ? 'light' : 'dark', true );
	} );

	// Include the active theme when switching language so the reload can sync localStorage.
	$( document ).on( 'submit', 'form[action*="set-language.php"]', function () {
		const theme = document.documentElement.getAttribute( 'data-bs-theme' ) === 'dark' ? 'dark' : 'light';
		let $input = $( this ).find( 'input[name="cp_theme"]' );

		if ( !$input.length ) {
			$input = $( '<input>', {
				type: 'hidden',
				name: 'cp_theme',
			} ).appendTo( this );
		}

		$input.val( theme );
	} );

	// Follow OS theme changes only while the user has no explicit stored preference.
	const mediaQuery = window.matchMedia( '(prefers-color-scheme: dark)' );
	const onSystemThemeChange = () => {
		if ( getStoredTheme() ) {
			return;
		}

		setTheme( getPreferredTheme(), false );
	};

	if ( typeof mediaQuery.addEventListener === 'function' ) {
		mediaQuery.addEventListener( 'change', onSystemThemeChange );
	} else if ( typeof mediaQuery.addListener === 'function' ) {
		mediaQuery.addListener( onSystemThemeChange );
	}

	// Configure topbar with site colors.
	if ( typeof topbar !== 'undefined' ) {
		topbar.config( {
			autoRun: true,
			barThickness: 5,
			barColors: {
				'.3': 'rgba(255, 172, 36, 1)',
				0: 'rgba(255, 172, 36, 1)',
				'1.0': 'rgba(255, 172, 36, 1)',
			},
			shadowBlur: 5,
			shadowColor: 'rgba(0, 0, 0, .5)',
			className: 'topbar',
		} );

		// Show topbar on page load.
		topbar.show();
		topbar.progress( 0.6 );

		// Hide topbar when document is ready.
		$( document ).ready( function () {
			topbar.hide();
		} );

		// Show topbar on link clicks (navigation).
		$( document ).on( 'click', 'a', function ( e ) {
			const href = $( this ).attr( 'href' );

			// Skip if href is not defined or empty.
			if ( !href ) {
				return;
			}

			// Keep native behaviour for new-tab/window gestures (Ctrl/Cmd/Shift/Alt-click, non-primary button).
			if (
				e.ctrlKey ||
				e.metaKey ||
				e.shiftKey ||
				e.altKey ||
				( typeof e.button === 'number' && e.button !== 0 )
			) {
				return;
			}

			if (
				!$( this ).attr( 'target' ) &&
				!$( this ).hasClass( 'fileinput-upload' ) &&
				href.indexOf( '#' ) === -1
			) {
				e.preventDefault();

				if ( href.indexOf( '#' ) === -1 && href !== '' ) {
					topbar.show();
					topbar.progress( 0.5 );
					setTimeout( function () {
						document.location.href = href;
					}, 100 );
				}
			}
		} );

		// Show topbar on form submissions.
		$( document ).on( 'submit', 'form', function () {
			const method = $( this ).attr( 'method' );
			const validationForm = $( this ).hasClass( 'bv-form' );

			if ( method === 'post' && !validationForm ) {
				topbar.show();
				topbar.progress( 0.5 );
			}
		} );
	}

	// Avatar image loading handler.
	const $avatar = $container.find( '#user-avatar' );

	if ( $avatar.length ) {
		const $avatarImg = $avatar.find( 'img' );
		const fallbackInitials = config.initials || '';

		if ( $avatarImg.length ) {
			$avatarImg.on( 'load', function () {
				$avatar.addClass( 'has-avatar' );
			} );

			$avatarImg.on( 'error', function () {
				$avatar.removeClass( 'has-avatar' );
				$avatar.html( fallbackInitials );
			} );

			// Trigger load check for cached images.
			if ( $avatarImg[ 0 ].complete ) {
				if ( $avatarImg[ 0 ].naturalWidth > 0 ) {
					$avatar.addClass( 'has-avatar' );
				} else {
					$avatar.removeClass( 'has-avatar' );
					$avatar.html( fallbackInitials );
				}
			}
		}
	}

	// OpenReplay initialization.
	if ( config.openReplayEnabled && config.openReplayUid ) {
		const initOpts = {
			projectKey: 'WYnGkgRsK63XK8e0xn3N',
			ingestPoint: `${window.location.origin}/openreplay-ingest`,
			defaultInputMode: 0,
			obscureTextNumbers: false,
			obscureTextEmails: false,
			captureIFrames: false,
		};
		const startOpts = {
			sessionHash: atob( config.openReplayUid ),
		};

		( function ( t, s, e, n, u, o ) {
			window.OpenReplay = [
				u,
				o,
				n,
				[
					s - 1,
					u,
				],
			];
			o = window.OpenReplay;
			s = document.createElement( 'script' );
			s.src = t;
			s.async = true;
			document.getElementsByTagName( 'head' )[ 0 ].appendChild( s );
			o.start = function () {
				o.push( [ 0 ] );
			};
			o.stop = function () {
				o.push( [ 1 ] );
			};
			o.setUserID = function ( id ) {
				o.push( [
					2,
					id,
				] );
			};
			o.setUserAnonymousID = function ( id ) {
				o.push( [
					3,
					id,
				] );
			};
			o.setMetadata = function ( key, val ) {
				o.push( [
					4,
					key,
					val,
				] );
			};
			o.event = function ( name, payload, issue ) {
				o.push( [
					5,
					name,
					payload,
					issue,
				] );
			};
			o.issue = function ( name, payload ) {
				o.push( [
					6,
					name,
					payload,
				] );
			};
			o.isActive = function () {
				return false;
			};
			o.getSessionToken = function () {};
		} )(
			atob( 'Ly9zdGF0aWMub3BlbnJlcGxheS5jb20vbGF0ZXN0L29wZW5yZXBsYXkuanM=' ),
			1,
			0,
			initOpts,
			startOpts
		);
	}
};
